import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_slice_generation, use_slice_ui } from '@/hooks/store/use_slices';
import { useToast } from '@/hooks/use-toast';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { LOCAL__ui_set_boolean } from '@/state/ui/_base/LOCAL__ui_set_boolean';
import { LOCAL__ui_drag_and_drop_set_hovered_graph_field } from '@/state/ui/drag_and_drop/LOCAL__ui_drag_and_drop_set_hovered_graph_field';
import { FN_IMAGE_FILE_DATA__upload_to_workspace_and_set_to_graph_list } from '@/utils/_methods/FN_IMAGE_FILE_DATA__upload_to_workspace_and_set_to_graph_list';
import { FN_FILE_LIST__to_file_data_list } from '@/utils/utils_upload';
import { CONSTANTS__shared } from '@shared/constants/CONSTANTS__shared';
import { FIELD__list_image_asset } from '@shared/dto/generation/graph_invoke/_fields/_primitives/list/FIELD__list_image_asset';
import { ENUM__image_asset_category } from '@shared/dto/generation/graph_invoke/_fields/ENUM__image_asset_category';
import { useTranslation } from 'react-i18next';
import { G_DRAG_AND_DROP__area_with_label } from '../../_base/_drag_and_drop/G_DRAG_AND_DROP__area_with_label';

interface PROPS {
  field: FIELD__list_image_asset;
}

export function G_GRAPH__DRAG_AND_DROP__list_images_external({ field }: PROPS) {
  /*
   * STORE
   */

  const dispatch = use_dispatch();
  const { toast } = useToast();
  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_GENERATION);

  const { generation_current } = use_slice_generation(['generation_current']);

  const { drag_and_drop__image_external_zones_show } = use_slice_ui(['drag_and_drop__image_external_zones_show']);
  const { g_general__ui_disabled } = use_slice_ui(['g_general__ui_disabled']);

  /*
   * STATE
   */

  /*
   * EVENTS
   */

  function onDrop(e: React.DragEvent): void {
    debugger;

    e.preventDefault();
    e.stopPropagation();

    void upload_file(e.dataTransfer.files);

    dispatch(LOCAL__ui_set_boolean({ key: 'drag_and_drop__image_external_zones_show', value: false }));
    dispatch(LOCAL__ui_drag_and_drop_set_hovered_graph_field());
  }

  /*
   * METHODS
   */

  async function upload_file(files_list: FileList) {
    if (field.items.length >= CONSTANTS__shared.IP_ADAPTER_IMAGES_LIMIT) return;

    let limit = CONSTANTS__shared.IP_ADAPTER_IMAGES_LIMIT - field.items.length;

    let file_data_list = await FN_FILE_LIST__to_file_data_list(toast, files_list, t, limit);

    FN_IMAGE_FILE_DATA__upload_to_workspace_and_set_to_graph_list(file_data_list, field);
  }

  function get_class_name_opacity() {
    return drag_and_drop__image_external_zones_show ? ' opacity-100 ' : ' opacity-0 ';
  }

  function is_interactive() {
    let out = true;

    if (!drag_and_drop__image_external_zones_show) {
      out = false;
    } else if (field.category != ENUM__image_asset_category.IMAGE) {
      out = false;
    } else if (field.items.length >= CONSTANTS__shared.IP_ADAPTER_IMAGES_LIMIT) {
      out = false;
    } else if (!field.is_ready_for_manual_edit()) {
      out = false;
    }

    return out;
  }

  function get_text() {
    let out = '';

    if (field.category != ENUM__image_asset_category.IMAGE) {
      out = 'Not for external images';
    } else if (!field.is_ready_for_manual_edit()) {
      out = 'Read Only Field';
    } else if (field.items.length >= CONSTANTS__shared.IP_ADAPTER_IMAGES_LIMIT) {
      out = 'List is Full';
    } else {
      out = 'Drop Image Here';
    }

    return out;
  }

  /*
   * RENDERS
   */

  /*
   * HTML
   */
  // if (!drag_and_drop__image_external_zones_show) return null;
  // if (!field.field_image_main.get_can_be_changed_manually(generation_current.graph))
  //   return <G_DRAG_AND_DROP__area_with_label text="Read Only" not_interactive={true} />;

  // todo: use animation border instead of static
  //todo: animate on hover

  if (g_general__ui_disabled) return null;

  return (
    <div
      data-drag-and-drop-zone-graph-field={field.meta.field_id}
      {...{ onDrop }}
      className={`info_drag_and_drop_image_list_external
    absolute inset-0 z-50
    flex-center p-4
    text-center text-white 
    rounded-lg
    ${get_class_name_opacity()}
    ${is_interactive() ? ' border border-2 border-dashed border-component-border ' : ' pointer-events-none bg-black '}
  `}
    >
      {/* content */}
      <G_DRAG_AND_DROP__area_with_label text={get_text()} class_name="bg-white/10" />
    </div>
  );
}
